import { ReportField, ReportRecord } from "./report-payload";
import { ReportType } from "./report-types";

export interface ReportTableColumn {
  /** Nombre del campo que corresponde al ReportTableRow */
  field: ReportField | string;

  /** Etiqueta visible en la tabla */
  header: string;

  /** Ancho de la columna (px, %, etc.) */
  width?: string;

  /** Tipo de presentación: text, link, input, select, custom */
  type: 'text' | 'link' | 'input' | 'select' | 'custom' | "img" | "date" | "number";

  /** Subcolumnas si esta columna es un grupo */
  subColumns?: ReportTableColumn[];

  hidden? : boolean;
}

export enum ReportTableType {
  PAGINATOR = 'PAGINATOR',
  VIRTUAL_SCROLL = 'VIRTUAL_SCROLL'
}

export const reportTableModeMap : Record<ReportTableType, ReportType[]> = {
  [ReportTableType.PAGINATOR] : [
    ReportType.REPORTE_CHECKLIST,
    ReportType.REPORTE_ATENCION_EVENTOS,
  ],
  [ReportTableType.VIRTUAL_SCROLL] : [],
}


export type ReportTableRow = ReportRecord 